// Shared display formatters for Analyzer cards. Behavior is identical to
// the inline helpers in the original AnalyzerDataCheck.jsx -- do not
// change output.
import { MARKET_SHORT } from "./constants";

export const formatOdds = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  if (typeof n === "string") return n;
  return n > 0 ? `+${n}` : `${n}`;
};

export const formatAge = (m) => {
  if (typeof m !== "number") return "";
  if (m < 1) return "just now";
  if (m < 60) return `${Math.round(m)}m ago`;
  const h = m / 60;
  if (h < 24) return `${Math.round(h)}h ago`;
  return `${Math.round(h / 24)}d ago`;
};

export function formatLegLine(leg) {
  const m = MARKET_SHORT[leg?.market] || leg?.market || "—";
  const side = leg?.side ? leg.side[0].toUpperCase() + leg.side.slice(1) : "";
  const line = leg?.user_line ?? leg?.line ?? "—";
  const player = leg?.player_name || "Unknown";
  return `${player} · ${side} ${line} ${m}`.trim();
}
